import AppStoreBadge from 'components/AppStoreBadge';
import GooglePlayBadge from 'components/GooglePlayBadge';
import { TEXT } from 'locales/translations';
import { Button, Paragraph } from 'Common';
import { getColorSetByPrimaryColor, redirectToStoreDownload } from 'utils';
import Style from './CtaZppInfoSection.style';

export const CtaZppInfoSection = ({ backgroundColor }) => {
  const color = getColorSetByPrimaryColor(backgroundColor);
  return (
    <Style id="section-appstores" className="cta-info-section" backgroundColor={color.themeColor}>
      <Paragraph className="bold text-center">{TEXT.ctaInfoSection.zpp.headline}</Paragraph>
      <div className="center">
        <Button color={color.themeColor} variant="inverted" onClick={redirectToStoreDownload}>
          {TEXT.ctaInfoSection.btn}
        </Button>
        <ul className="cta-info-section__store-button-row">
          <li>
            <AppStoreBadge />
          </li>
          <li>
            <GooglePlayBadge />
          </li>
        </ul>
      </div>
    </Style>
  );
};
